import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0b5366', dark: '#083b4b', light: '#d9eef2' },
    secondary: { main: '#147d82', dark: '#0d5c61', light: '#d9f0ee' },
    background: { default: '#f4f8fa', paper: '#ffffff' },
    text: { primary: '#19323d', secondary: '#546b76' },
    success: { main: '#237a57' },
    warning: { main: '#a45a11' },
  },
  typography: {
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontWeight: 760, letterSpacing: '-0.035em' },
    h2: { fontWeight: 720, letterSpacing: '-0.025em' },
    h3: { fontWeight: 700, letterSpacing: '-0.015em' },
    button: { fontWeight: 680, textTransform: 'none' },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid #dce7eb',
          boxShadow: '0 14px 38px rgba(8, 59, 75, 0.07)',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: '0.82rem', lineHeight: 1.5, maxWidth: 360 },
      },
    },
  },
});

export default theme;
